<template>
  <div class="marketInfo">
    <div class="jumpPage">
      <span class="jumpPage-btn" @click="backTop"
        ><i class="el-icon-back"></i>返回</span
      >
      <a v-if="linkInfo?.linkUrl" class="jumpPage-a" target="_blank" :href="linkInfo.linkUrl"
        >点击跳转外部链接</a
      >
    </div>
    <div class="content">
      <h3>{{ contentInfo.title }}</h3>
      <p>{{ contentInfo.gmtCreated }}</p>
      <img
        v-if="contentInfo.coverImage"
        :src="localUrl + contentInfo.coverImage"
        alt=""
      />
      <div class="text" v-html="contentInfo.content"></div>
    </div>
  </div>
</template>

<script>
import { getServiceContent } from '@/API/goverment/goverment';
export default {
  name: 'marketInfo',
  props: {
    linkInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      contentInfo: {},
      localUrl: process.env.VUE_APP_BASE_URL,
    };
  },
  mounted() {
    if (this.linkInfo.linkParams && this.linkInfo.linkParams.articleId) {
      this.getInfo(this.linkInfo.linkParams.articleId);
    }
  },
  methods: {
    getInfo(id) {
      getServiceContent(id).then((res) => {
        if (res.code === 200) {
          this.contentInfo = res.data;
        }
      });
    },
    backTop() {
      this.$emit('backTop');
    },
  },
};
</script>

<style lang="less" scoped>
.marketInfo {
  width: 1400px;
  margin: auto;
  .jumpPage {
    width: inherit;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .jumpPage-btn,
    .jumpPage-a {
      font-size: 16px;
      cursor: pointer;
      color: #409eff;
    }
  }
}
.content {
  margin: 20px 0;
  width: inherit;
  h3 {
    font-size: 28px;
    text-align: center;
    line-height: 36px;
  }
  p {
    font-size: 18px;
    text-align: center;
    line-height: 36px;
    color: #636363;
  }
  img {
    width: 100%;
    height: 320px;
    margin: 30px 0;
  }
  .text {
    font-size: 20px;
  }
}
</style>
